import {Component, Input, OnInit} from '@angular/core';
import {EnvironmentService} from '../../../../services/environment.service';
import {EvaluationBaseTileComponent} from '../tile.component';
import {ScormCloudService} from '../../../../services/scorm-cloud.service';

@Component({
  selector: 'itpx-evaluation-scorm-cloud-tile',
  templateUrl: './tile.component.html',
  styleUrls: ['./tile.component.css']
})

export class EvaluationScormCloudTileComponent extends EvaluationBaseTileComponent implements OnInit {
  @Input() deliverable: any;

  private images: string;
  private href: string = '#';
  @Input() profile: any;

  constructor(
    private environmentService: EnvironmentService,
    private scormCloudService: ScormCloudService,
  ) {
    super();
  }

  ngOnInit() {
    this.images = this.environmentService.config['server'].images;
    super.initScormCloud(this.scormCloudService, this.deliverable, true);
  }

  complete(deliverable: any, createTarget: boolean) {
    if (!deliverable.disabled)
      this.href = '/evaluation/' + deliverable.type + '/' + deliverable.id;
    super.complete(deliverable, createTarget);
  }

}



// WEBPACK FOOTER //
// ./src/app/core/components/evaluation/content/scormcloud/tile.component.ts